<template>
    <header ref="gnb" id="header" class="header" :class="[{ 'header-white': gnbType }]">
      <v-container class="py-0">
        <v-row>
          <v-col cols="12" xl="8" offset-xl="2" class="py-0">
            <div class="d-flex align-center py-3">
              <a href="/" class="logo">
                <h1>
                  <span class="d-sr-only">FINBRIDGE</span>
                </h1>
              </a>
              <v-spacer />
              <nav>
                <v-menu offset-y open-on-hover transition="slide-y-transition" bottom v-for="(menu, index) in menus" :key="index" ref="menuRef" min-width="130px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn text v-if="!menu.depth2" :to="{ name: menu.pathName }" :class="{'v-btn--active' : $route.path.includes(menu.rootPathName)}">{{ menu.title }}</v-btn>
                    <v-btn text v-if="menu.depth2" v-bind="attrs" v-on="on" :class="{'v-btn--active' : $route.path.includes(menu.rootPathName)}">{{ menu.title }}</v-btn>
                  </template>
                  <v-list>
                    <v-list-item v-for="(menu, index) in menu.depth2" :key="index">
                      <v-list-item-title>
                        <router-link class="nav-sub-btn" :to="{ name: menu.pathName }" v-html="menu.title"></router-link>
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </nav>
              <nav-mobile />
            </div>
          </v-col>
        </v-row>
      </v-container>
    </header>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import NavMobile from "@/pages/components/layout/NavMobile.vue";
import menus from "@/assets/js/menus.json";

const { mapGetters, mapActions } = createNamespacedHelpers("ui");

export default {
  name: "Gnb",
  components: {
    NavMobile
  },
  data() {
    return {
      menus: menus
    };
  },
  computed: {
    ...mapGetters(["gnbType"])
  },
  methods: {
    ...mapActions(["setGnbType", "setIsDimmed"]),
    handleScroll() {
      let isChangeGnbType = document.documentElement.scrollTop > 50;

      if (isChangeGnbType) {
        this.setGnbType("white");
      } else {
        this.setGnbType("");
      }
    }
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
    this.setIsDimmed(false);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  }
};
</script>

<style lang="scss" scoped>
.header {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 200;
  transition: all 0.3s;
  .logo {
    width: 128px;
    height: 24px;
    margin-left: 18px;
    background: url("~@/assets/new/logo-white.svg") no-repeat 0 0;
    background-size: contain;
  }
  nav {
    display: none;
    .v-btn {
      font-size: 13px;
      letter-spacing: -0.4px;
      margin-left: 16px;
      color: white;
      &:first-child {
        margin-left: 0;
      }
      &:hover {
        color: white;
      }
      &--active {
        &:hover,
        &:focus {
          &::before {
            opacity: 0.04;
          }
        }
        &::before {
          opacity: 0.04;
        }
      }
    }
    
  }
  &-white {
    background-color: #fff;
    &:after {
      content: "";
      display: block;
      height: 1px;
      background-color: #F0F3F5;
    }
    .logo {
      background-image: url("~@/assets/new/logo-blue.svg");
    }
    nav {
      .v-btn {
        color: #001523;
        &:hover {
          color: #001523;
        }
      }
    }
  }

  @include respond-to("small") {
    .logo {
      width: 149px;
      height: 28px;
      margin-left: 30px;
    }
    nav {
      display: flex;
      margin-right: 30px;
    }
  }

  @include respond-to("medium") {
    .logo {
      width: 149px;
      height: 28px;
      margin-left: 0px;
    }
    nav {
      display: flex;
      margin-right: 0;
    }
  }
}

.v-list-item {
  padding: 12px 18px;
  min-height: 20px;
  .nav-sub-btn {
    font-size: 13px;
    font-weight: 500;
    color: #001523;
    text-decoration: none;
    &:hover,
    &.active {
      color: #006fbc;
    }
  }
}
</style>